import React from "react";
import FormField, { SelectInput } from "../common/FormField";
import { describeRule } from "./RuleEditor";

const versions = [
  ["base", "При выгрузке"],
  ["current", "Сейчас в программе"],
  ["imported", "В Excel"],
];

function display(value, field, paths) {
  if (value === null || value === undefined || value === "")
    return "Не заполнено";
  if (field === "status")
    return value === "active" ? "Используется" : "Выведена из использования";
  if (field === "condition") return describeRule(value, paths);
  if (Array.isArray(value)) return value.join(", ") || "Пустой набор";
  if (typeof value === "object")
    return Object.entries(value)
      .map(([key, label]) => `${key}: ${label}`)
      .join("; ");
  return String(value);
}

export default function ImportConflict({
  conflict,
  spec,
  paths,
  value,
  onChange,
}) {
  const keys = [
    ...new Set(
      versions.flatMap(([key]) => Object.keys(conflict[key]?.data || {})),
    ),
  ];
  const different = (key) =>
    new Set(
      versions.map(([version]) =>
        JSON.stringify(
          key === "status"
            ? conflict[version]?.status
            : (conflict[version]?.data?.[key] ?? null),
        ),
      ),
    ).size > 1;
  const fields = ["status", ...keys].filter(different);
  const labels = Object.fromEntries(
    (spec?.fields || []).map((field) => [field.key, field.label]),
  );
  return (
    <section
      className="classifier-rule"
      aria-label={`Конфликт ${conflict.key}`}
    >
      <h3>Конфликт {conflict.key}</h3>
      <p>
        Запись изменена после выгрузки и в программе, и в Excel. Сравните
        значения перед выбором; решение применяется ко всей записи.
      </p>
      {fields.map((field) => (
        <div className="classifier-conflict-field" key={field}>
          <h4>
            {field === "status" ? "Использование" : labels[field] || field}
          </h4>
          <div className="classifier-conflict-values">
            {versions.map(([version, label]) => (
              <div key={version}>
                <strong>{label}</strong>
                <p>
                  {!conflict[version]
                    ? "Записи нет"
                    : display(
                        field === "status"
                          ? conflict[version].status
                          : conflict[version].data[field],
                        field,
                        paths,
                      )}
                </p>
              </div>
            ))}
          </div>
        </div>
      ))}
      <FormField label={`Решение для ${conflict.key}`}>
        <SelectInput
          value={value || ""}
          onChange={(event) => onChange(event.target.value)}
        >
          <option value="">Выберите решение</option>
          <option value="current">Оставить версию программы</option>
          <option value="imported">Явно принять версию Excel</option>
        </SelectInput>
      </FormField>
    </section>
  );
}
